export default __webpack_public_path__ + "static/media/ic_product_wiener-staedtische.71958062.svg";